import * as React from "react";
import { Button, Drawer, TextField } from "@mui/material";
import { useMutation } from "react-query";
import { checkPincodeFn } from "../../Services/Products/CheckPincode";
import { useState } from "react";
const EnterPincode = () => {
  const [open, setOpen] = React.useState(false);
  const [pincode, setPincode] = useState(null);
  const [delivery, setDelivery] = useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const { mutate: checkPincode } = useMutation(checkPincodeFn, {
    onSuccess: (response) => {
      response.data.response_code === 200 &&
        setDelivery(
          `Delivery within ${response.data.delivery_time} in ${response.data.city_name}`
        );
    },
  });

  const handleChange = (event) => {
    event.target.value.length === 6
      ? checkPincode({ zipcode: event.target.value })
      : setDelivery("");
    setPincode(event.target.value);
  };
  const handleSave = (event) => {
    event.preventDefault();
    localStorage.setItem("pincode", pincode);
    setDelivery("");
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        className="!rounded-sm !capitalize"
        onClick={handleClickOpen}
      >
        {localStorage.getItem("pincode") ? (
          <p>{localStorage.getItem("pincode")}, Change</p>
        ) : (
          "Enter Pincode"
        )}
      </Button>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={handleClose}
        PaperProps={{
          className: "!rounded-t-lg p-2 flex flex-col gap-3",
        }}
      >
        <span className="flex justify-center" onClick={handleClose}>
          <span className="h-[6px] w-24 rounded-full bg-zinc-200 dark:bg-zinc-700"></span>
        </span>
        <form onSubmit={handleSave} className="p-2 flex flex-col gap-3">
          <TextField
            label="Enter Pincode"
            type="number"
            defaultValue={localStorage.getItem("pincode")}
            onChange={handleChange}
            className="w-full"
          />
          <p className="px-2 text-center h-5">{delivery}</p>
          <Button
            disableElevation
            type="submit"
            variant="contained"
            className="px-2"
          >
            Save
          </Button>
        </form>
      </Drawer>
    </>
  );
};
export default EnterPincode;
